/**
 * Gestionnaire de bandeau de consentement
 * Gère l'affichage, le stockage et la logique du bandeau de consentement
 */
class ConsentBanner {
  constructor() {
    this.storageKey = 'consent';
    this.bannerElement = null;
    this.init();
  }

  init() {
    // Vérifier si l'utilisateur a déjà donné son consentement
    if (this.hasConsentBeenGiven()) {
      console.log('ConsentBanner: Consentement déjà donné, bandeau masqué');
      return;
    }

    console.log('ConsentBanner: Aucun consentement trouvé, affichage du bandeau');
    
    // Le script est chargé avec defer, donc le DOM est déjà prêt
    // Attendre un petit délai pour s'assurer que tout est chargé
    setTimeout(() => {
      this.showBanner();
    }, 100);
  }

  hasConsentBeenGiven() {
    try {
      const consent = localStorage.getItem(this.storageKey);
      return consent === 'accepted' || consent === 'declined';
    } catch (error) {
      console.warn('Erreur lors de la lecture du localStorage:', error);
      return false;
    }
  }

  showBanner() {
    console.log('ConsentBanner: showBanner() appelée');
    this.bannerElement = document.querySelector('.consent-banner');
    
    if (!this.bannerElement) {
      console.warn('ConsentBanner: Élément de bandeau de consentement non trouvé');
      console.log('ConsentBanner: Éléments avec classe consent-banner:', document.querySelectorAll('.consent-banner'));
      return;
    }

    console.log('ConsentBanner: Bandeau trouvé, ajout de la classe show');

    // Ajouter la classe pour afficher le bandeau avec animation
    setTimeout(() => {
      this.bannerElement.classList.add('show');
      document.body.classList.add('consent-banner-open');
      console.log('ConsentBanner: Classe show ajoutée, classes actuelles:', this.bannerElement.className);
    }, 100);

    // Attacher les événements
    this.attachEvents();
  }

  attachEvents() {
    const acceptButton = this.bannerElement.querySelector('.consent-banner__button--accept');
    const declineButton = this.bannerElement.querySelector('.consent-banner__button--decline');

    if (acceptButton) {
      acceptButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleConsent('accepted');
      });
    }

    if (declineButton) {
      declineButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleConsent('declined');
      });
    }
  }

  handleConsent(choice) {
    try {
      // Sauvegarder le choix dans localStorage
      localStorage.setItem(this.storageKey, choice);
      
      // Déclencher un événement personnalisé
      const event = new CustomEvent('consent-banner-choice', {
        detail: { choice: choice }
      });
      document.dispatchEvent(event);

      // Masquer le bandeau
      this.hideBanner();

      // Log pour le développement (peut être supprimé en production)
      console.log(`Consentement ${choice === 'accepted' ? 'accepté' : 'refusé'}`);
      
    } catch (error) {
      console.error('Erreur lors de la sauvegarde du consentement:', error);
      // Masquer quand même le bandeau même en cas d'erreur
      this.hideBanner();
    }
  }

  hideBanner() {
    if (!this.bannerElement) return;

    // Animation de sortie
    this.bannerElement.classList.remove('show');
    this.bannerElement.classList.add('hide');
    
    // Retirer la classe du body
    document.body.classList.remove('consent-banner-open');

    // Supprimer l'élément du DOM après l'animation
    setTimeout(() => {
      if (this.bannerElement && this.bannerElement.parentNode) {
        this.bannerElement.parentNode.removeChild(this.bannerElement);
      }
    }, 300);
  }

  // Méthode publique pour réinitialiser le consentement (utile pour les tests)
  resetConsent() {
    try {
      localStorage.removeItem(this.storageKey);
      console.log('Consentement réinitialisé');
    } catch (error) {
      console.error('Erreur lors de la réinitialisation du consentement:', error);
    }
  }

  // Méthode publique pour vérifier le statut actuel du consentement
  getConsentStatus() {
    try {
      return localStorage.getItem(this.storageKey);
    } catch (error) {
      console.error('Erreur lors de la lecture du statut de consentement:', error);
      return null;
    }
  }

  // Méthode publique pour réafficher le bandeau (pour la gestion des consentements)
  showBannerForManagement() {
    console.log('ConsentBanner: showBannerForManagement() appelée pour gestion des consentements');
    
    // Retirer la classe du body
    document.body.classList.remove('consent-banner-open');

    // Trouver le bandeau existant dans le DOM (sans le supprimer d'abord)
    this.bannerElement = document.querySelector('.consent-banner');
    
    if (!this.bannerElement) {
      console.warn('ConsentBanner: Élément de bandeau de consentement non trouvé pour la gestion');
      // Essayer de recréer le bandeau en rechargeant la page
      console.log('ConsentBanner: Tentative de rechargement de la page pour recréer le bandeau');
      location.reload();
      return;
    }

    // Supprimer les classes d'animation existantes
    this.bannerElement.classList.remove('show', 'hide');
    
    // Afficher le bandeau immédiatement sans vérifier le localStorage
    setTimeout(() => {
      this.bannerElement.classList.add('show');
      document.body.classList.add('consent-banner-open');
    }, 50);
    
    // Attacher les événements
    this.attachEvents();
    
    console.log('ConsentBanner: Bandeau affiché pour gestion des consentements');
  }

  // Méthode de test pour forcer l'affichage (pour débogage)
  forceShow() {
    console.log('ConsentBanner: ForceShow() appelée');
    this.bannerElement = document.querySelector('.consent-banner');
    
    if (!this.bannerElement) {
      console.warn('ConsentBanner: Pas de bandeau trouvé pour forcer l\'affichage');
      return;
    }

    // Forcer l'affichage immédiatement
    this.bannerElement.style.transform = 'translateY(0)';
    this.bannerElement.style.opacity = '1';
    this.bannerElement.classList.add('show');
    document.body.classList.add('consent-banner-open');
    
    console.log('ConsentBanner: Affichage forcé appliqué');
    this.attachEvents();
  }
}

// Initialiser le bandeau de consentement
document.addEventListener('DOMContentLoaded', function() {
  window.consentBanner = new ConsentBanner();
});

// Exposer la classe globalement pour un accès externe si nécessaire
window.ConsentBanner = ConsentBanner;

// Méthodes utilitaires globales pour le débogage
window.testConsentBanner = {
  // Réinitialiser le consentement et forcer l'affichage
  reset: function() {
    localStorage.removeItem('consent');
    console.log('Consentement réinitialisé, rechargement de la page...');
    location.reload();
  },
  
  // Forcer l'affichage immédiat
  forceShow: function() {
    if (window.consentBanner) {
      window.consentBanner.forceShow();
    } else {
      console.error('ConsentBanner non initialisé');
    }
  },
  
  // Vérifier le statut
  status: function() {
    console.log('Statut du consentement:', localStorage.getItem('consent'));
    console.log('Instance ConsentBanner:', !!window.consentBanner);
  },
  
  // Tester le lien de gestion
  testManageLink: function() {
    console.log('=== TEST DU LIEN DE GESTION ===');
    console.log('1. Instance ConsentBanner:', !!window.consentBanner);
    console.log('2. Élément bandeau dans DOM:', !!document.querySelector('.consent-banner'));
    console.log('3. Classes du bandeau:', document.querySelector('.consent-banner')?.className);
    console.log('4. Appel de showBannerForManagement()...');
    if (window.consentBanner) {
      window.consentBanner.showBannerForManagement();
    }
  }
};
